'use strict';
import MarkerClusterer from '@google/markerclustererplus';

class FindMemberOrganisationMap {
    constructor() {
        this.filterView = document.querySelector(".fmo-filter");
        this.mapView = document.querySelector("#map-view");
        this.mapContainer = document.querySelector("#fmo-map");
        this.map = {};
        this.oms = {};
        this.currentMarkers = [];
        this.currentInfoWindow = {};
        this.baseUrl = window.location.href.split('?')[0];
        this.spiderfied = false;

        if (this.mapContainer) {
            var script = document.createElement('script');
            script.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.mapContainer.dataset.apikey + '&callback=initMap';
            script.defer = true;
            script.async = true;

            window.initMap = () => {                
                var branchSelector = document.querySelector("#fmo-branch-list");
                if (!branchSelector.value) { //Trigger load of default map if no search should trigger
                    this.loadMap();
                }
            };

            document.head.appendChild(script);

            document.addEventListener("fmo.loading", evt => {
                this.addLoading();
            });
            document.addEventListener("fmo.resultLoaded", evt => {
                this.removeLoading();
                this.currentMarkers = [];
                this.currentInfoWindow = {};
                
                if (evt.detail.result.length > 0) {
                    [].forEach.call(evt.detail.result, memberorganisation => {
                        if (memberorganisation.geoLocation) {
                            this.currentMarkers.push(this.createMarker(memberorganisation));
                        }
                    });
                }
                this.loadMap();
            });    
            document.addEventListener("fmo.resultReset", evt => {
                this.currentMarkers = [];
                this.currentInfoWindow = {};
                this.loadMap();
            });
        }
    }
    addLoading() {
        this.filterView.classList.add("loading-map");
        this.mapView.classList.add("loading-map");
    }
    removeLoading() {
        this.filterView.classList.remove("loading-map");
        this.mapView.classList.remove("loading-map");
    }    
    loadMap() {
        this.spiderfied = false;
        if (this.map.getZoom) {
            var prevZoom = this.map.getZoom();
            var prevCenter = this.map.getCenter();
        }
        this.map = new google.maps.Map(this.mapContainer, {
            zoomControl: String(this.mapContainer.dataset.showzoomcontrol).toLowerCase() === 'true',
            fullscreenControl: String(this.mapContainer.dataset.showfullscreencontrol).toLowerCase() === 'true',
            mapTypeControl: String(this.mapContainer.dataset.showmaptypecontrol).toLowerCase() === 'true',
            streetViewControl: String(this.mapContainer.dataset.showstreetviewcontrol).toLowerCase() === 'true',
            gestureHandling: 'greedy',
            scrollwheel: false,
            styles: this.getMapStyle()
        });        
        
        if (this.currentMarkers.length > 0) {
            var bounds = new google.maps.LatLngBounds();
            if (this.currentMarkers.length) {
                [].forEach.call(this.currentMarkers, marker => {
                    bounds.extend(marker.position);
                });
            }
            google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
                this.map.setZoom(Math.min(parseInt(this.mapContainer.dataset.maxzoom), this.map.getZoom()));
                this.map.setZoom(Math.max(parseInt(this.mapContainer.dataset.minzoom), this.map.getZoom()));
            });
            google.maps.event.addListener(this.map, 'zoom_changed', () => {                
                if (this.map.getZoom() >= 16 && !this.spiderfied) {
                    if (this.currentMarkers.length > 1000) {
                        console.warn("[FMO] Too large dataset for spiderfy, please narrow the result. Markers with duplicate addresses may not be visible in map.");
                    } else {
                        this.oms = new OverlappingMarkerSpiderfier(this.map, {
                            markersWontMove: true,
                            markersWontHide: true,
                            basicFormatEvents: true,
                            keepSpiderfied: true
                        });
                        if (this.currentMarkers.length) {
                            [].forEach.call(this.currentMarkers, marker => {
                                this.oms.addMarker(marker);
                            });
                        }
                        this.spiderfied = true;
                    }
                }
                if (this.currentInfoWindow.close) {
                    this.currentInfoWindow.close();
                }
            });
            this.map.fitBounds(bounds);

            var markerCluster = new MarkerClusterer(this.map, this.currentMarkers, {
                gridSize: parseInt(this.mapContainer.dataset.clustergrid),
                styles: this.getClusterStyle(),
                clusterClass: 'fmo_clustericon',
                maxZoom: 15
            });
            this.filterView.scrollIntoView();
        } else {            
            this.map.setZoom(5);
            this.map.setCenter(new google.maps.LatLng(62.3875, 16.325556));
            this.filterView.classList.add("loading-map"); //Hide counter
            document.dispatchEvent(new CustomEvent("fmo.emptyMapLoaded"));
        }
    }
    createMarker(memberorganisation) {        
        var image = {
            url: memberorganisation.isArbetsstalle ? "/icons/fmo_marker.svg" : "/icons/fmo_marker.svg",
            scaledSize: memberorganisation.isArbetsstalle ? new google.maps.Size(36, 45) : new google.maps.Size(36, 45)
        };
        var marker = new google.maps.Marker({
            position: new google.maps.LatLng(memberorganisation.GeoLocation.Latitude, memberorganisation.GeoLocation.Longitude),
            title: memberorganisation.name,
            icon: image,
            optimized: false
        });
        marker.addListener('click', evt => {
            if (this.currentInfoWindow.close) {
                this.currentInfoWindow.close();
            }
            this.currentInfoWindow = this.createInfoWindow(memberorganisation);
            this.currentInfoWindow.open(this.map, marker);
        });
        return marker;
    }
    createInfoWindow(memberorganisation) {
        return new google.maps.InfoWindow({
            maxWidth: 389,
            pixelOffset: { width: 240, height: 300 },
            content: this.createInfoWindowTemplate(memberorganisation)
        });
    }


    createInfoWindowTemplate(memberorganisation) {
        var template = this.getTemplateHeading(memberorganisation);

        if (memberorganisation.address) {
            template += `<span>Adress:</span>${memberorganisation.address}`;
        }
        if (memberorganisation.phone) {
            template += `<br /><span>Telefon:</span> <a href="tel:${memberorganisation.phone}">${memberorganisation.phone}</a>`;
        }
        if (memberorganisation.webpageUrl) {
            template += `<br /><span>Hemsida:</span> <a href="${memberorganisation.webpageUrl}" target="_blank">${memberorganisation.webpageUrl}</a>`;
        }
        template += `
                    </address>
                </div>`;
        return template;
    }

    getTemplateHeading(memberorganisation) {
        if(memberorganisation.webpageUrl) {
            return `<div class="fmo_map-infowindow">
                <h2><a href="${memberorganisation.webpageUrl}">${memberorganisation.name}</a></h2>                        
                <address>`;
        }

        return `<div class="fmo_map-infowindow">
        <h2>${memberorganisation.name}</h2>                        
        <address>`;

    }

    getMapStyle() {
        return [
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#1c4351"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#444444"
                    }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#1c4351"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#1c4351"
                    }
                ]
            },
            {
                "featureType": "administrative.locality",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#1c4351"
                    }
                ]
            },
            {
                "featureType": "administrative.neighborhood",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#1c4351"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#1c4351"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#d7ebf3"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#1c4351"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#1c4351"
                    }
                ]
            },
            {
                "featureType": "landscape.natural",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#1c4351"
                    }
                ]
            },
            {
                "featureType": "landscape.natural",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "weight": "1"
                    },
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#1c4351"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#ff0000"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#eef7fa"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#c8e4ee"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#1c4351"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#1c4351"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#46bcec"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#3d97b8"
                    }
                ]
            }
        ];
    }
    getClusterStyle() {
        return [
            {
                width: 32,
                height: 32
            },
            {
                width: 40,
                height: 40
            },
            {
                width: 48,
                height: 48
            }
        ];
    }
}

document.addEventListener("DOMContentLoaded", function () {
    new FindMemberOrganisationMap();
});